import React from 'react';
import defaults from '../../translations/en.json';

export const MessageOverlay = () => (
  <div
    className="ag-overlay-loading-center"
    style={{ backgroundColor: '#9edbf7', height: '10%' }}
  >
    <span>{defaults.saving}</span>
  </div>
);

export default MessageOverlay;
